import {updateCart} from "./cart";

const quantityInputs = [...document.querySelectorAll('.js-quantity-input')];

quantityInputs.forEach(quantityInput => {
    const input = quantityInput.querySelector('[data-input]');
    const plus = quantityInput.querySelector('[data-plus]');
    const minus = quantityInput.querySelector('[data-min]');

    plus.addEventListener('click', () => {
        let currentValue = parseInt(input.value, 10);
        input.value = currentValue + 1;

        setTimeout(() => {
            updateCart(quantityInput.dataset.id, Number(input.value));
        }, 20);
    });

    minus.addEventListener('click', () => {
        let currentValue = parseInt(input.value, 10);
        if (currentValue > 1) {
            input.value = currentValue - 1;
        }

        setTimeout(() => {
            updateCart(quantityInput.dataset.id, Number(input.value));
        }, 20);
    });

    input.addEventListener('change',(e) => {
        setTimeout(() => {
            updateCart(quantityInput.dataset.id, Number(input.value));
        }, 20);
    });



});
